import * as React from "react";
import {
  createColumnConfig,
  StandardTable,
  StandardTableConfig,
  TableContext,
} from "@stenajs-webui/grid";
import { SelectedMultiLegAgreement } from "../types";
import { HeadAgreementStatusCodeChip } from "@/components/chips/HeadAgreementStatusCodeChip";
import { Indent } from "@stenajs-webui/core";
import { formatGQLDateRange } from "@/lib/formatters/DateFormatter";
import { WorkFlowStatusCode } from "@/gql/graphql";

interface Props {
  headAgreementId: string;
  tableContext: TableContext<SelectedMultiLegAgreementColumns>;
  multiLegAgreements: Array<SelectedMultiLegAgreement>;
}

export type SelectedMultiLegAgreementColumns = keyof Omit<
  SelectedMultiLegAgreement,
  | "id"
  | "createdBy"
  | "dateCreated"
  | "dateModified"
  | "modifiedBy"
  | "rowVersion"
  | "__typename"
>;

const config: StandardTableConfig<
  SelectedMultiLegAgreement,
  SelectedMultiLegAgreementColumns
> = {
  keyResolver: (item) => item.id,
  showRowCheckbox: true,
  showHeaderCheckbox: true,
  disableSorting: true,
  columns: {
    statusCode: createColumnConfig((item) => item.statusCode, {
      columnLabel: "Status",
      renderCell: ({ label, item }) => (
        <Indent>
          <HeadAgreementStatusCodeChip statusCode={item.statusCode} />
        </Indent>
      ),
      minWidth: "90px",
    }),
    idNumber: createColumnConfig((item) => item.idNumber, {
      columnLabel: "Number",
      minWidth: "70px",
    }),
    route: createColumnConfig((item) => item.route.code, {
      columnLabel: "ML Route",
      minWidth: "100px",
    }),
    workFlowStatusCode: createColumnConfig(
      (item) =>
        item.workFlowStatusCode === WorkFlowStatusCode.Sready ? "YES" : "NO",
      {
        columnLabel: "Sales ready",
        minWidth: "82px",
      }
    ),
    name: createColumnConfig((item) => item.name, {
      columnLabel: "Name",
      minWidth: "250px",
    }),
    valid: createColumnConfig((item) => formatGQLDateRange(item.valid), {
      columnLabel: "Validity",
      minWidth: "171px",
    }),
    currency: createColumnConfig((item) => item.currency.id, {
      minWidth: "73px",
    }),
  },
  columnOrder: [
    "statusCode",
    "idNumber",
    "route",
    "workFlowStatusCode",
    "name",
    "valid",
    "currency",
  ],
};

export const SelectMultiLegAgreements: React.FC<Props> = ({
  tableContext,
  multiLegAgreements,
}) => {
  return (
    <StandardTable
      config={config}
      items={multiLegAgreements}
      tableContext={tableContext}
      noItemsLabel={
        "There are no multi leg agreements under this header agreement."
      }
    />
  );
};
